import {
  Filter,
  FilterItem,
  FilterSection,
  FilterType,
  PriceRange
} from '@/network/graphql.g'

export interface FilterModel {
  sizes?: FilterSection[]
  colors?: FilterSection[]
  patterns?: FilterSection[]
  materials?: FilterSection[]
  manufacturers?: FilterSection[]
  genders?: FilterSection[]
  categories?: FilterSection[]
  priceRange?: PriceRange
  sortTypes: FilterItem[]
  tags?: FilterSection[]
  hasInStock?: boolean
  hasInMainWarehouse?: boolean
}

export const convertAPIFilterToFilterType = (filter: Filter[]): FilterModel => {
  const sizes = findItemsForType(filter, FilterType.Sizes)
  const colors = findItemsForType(
    filter,
    FilterType.Colors,
    convertFilterItemToProductColor
  )
  const patterns = findItemsForType(
    filter,
    FilterType.Pattern,
    //TODO adjust is to motive filter
    convertFilterItemToProductColor
  )
  const materials = findItemsForType(filter, FilterType.Material) ?? []
  const manufacturers = findItemsForType(filter, FilterType.Manufacturer) ?? []
  const genders = findItemsForType(filter, FilterType.Gender) ?? []
  const categories = findItemsForType(filter, FilterType.Category) ?? []
  const priceRange = findFilter(filter, FilterType.Price)?.priceRange
  if (priceRange?.from) {
    priceRange.from = Math.round(priceRange.from)
  }
  if (priceRange?.to) {
    priceRange.to = Math.round(priceRange.to)
  }
  const sortTypes: FilterItem[] =
    findItemsForType(filter, FilterType.Sort)?.reduce(
      (prev, curr) => [...prev, ...curr.items],
      []
    ) ?? []
  const tags = findItemsForType(filter, FilterType.Tags2) ?? []
  const hasInStock = !!findFilter(filter, FilterType.InStock)
  const hasInMainWarehouse = !!findFilter(filter, FilterType.InMainWarehouse)

  return {
    sizes,
    colors,
    materials,
    manufacturers,
    genders,
    categories,
    priceRange,
    sortTypes,
    tags,
    patterns,
    hasInStock,
    hasInMainWarehouse
  }
}

const findFilter = (
  filter: Filter[],
  filterTypeToConvert: FilterType
): Filter =>
  filter?.find(({ filterType }) => filterType === filterTypeToConvert)

const findItemsForType = (
  filter: Filter[],
  filterTypeToConvert: FilterType,
  convert: (filterItem: FilterItem) => string = (filterItem) =>
    filterItem.value || filterItem.title
): FilterSection[] => {
  const filterItems = findFilter(filter, filterTypeToConvert)
  return filterItems?.filterItems?.map((filterSection) => ({
    ...filterSection,
    items: filterSection.items?.map((filterItem) => ({
      ...filterItem,
      value: convert(filterItem)
    }))
  }))
}

const convertFilterItemToProductColor = (item: FilterItem): string =>
  `rgb(${item.value})`
